import * as _ from "lodash";
import {TreeNode} from '@shared/components/abstract-component/tree-view.abstract';
import {StringUtils} from "@shared/utils/string-utils";
export class StructureUtils {
  static removeNodeInTreeArray(input: TreeNode[],remove: any,  property: string) {
    _.remove(input, v => {
      if (v[property] == remove) return true;
      else if (v.children) {
          return StructureUtils.removeNodeInTreeArray(v.children, remove, property);
      }
      return false;
    });
  }

  static findNodeInTreeArray(input: TreeNode[],find: any,  property: string) {
    return input.filter(v => {
      if (v[property] == find) return true;
      else if (v.children) {
        return StructureUtils.removeNodeInTreeArray(v.children, find, property);
      }
      return false;
    });
  }

  static expandNode(input: TreeNode[], find: any,  property: string, expandKeys: any[]) {
    if (!find) return;
    for (let i=0; i< input.length; i++) {
      const v =input[i];
      if (v[property] == find) {
        return v;
      }
      else if (v.children) {
        let exist = StructureUtils.expandNode(v.children, find, property, expandKeys);
        if (exist) {
          expandKeys.push(v[property] + "");
          return v;
        }
      }
    }
    return null;
  }

}
